var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 71.25C67.1413 71.25 74.2138 71.25 78.605 66.855C83 62.4637 83 55.3913 83 41.25C83 27.1088 83 20.0363 78.605 15.645C74.2138 11.25 67.1413 11.25 53 11.25H38C23.8588 11.25 16.7863 11.25 12.395 15.645C8 20.0363 8 27.1088 8 41.25C8 55.3913 8 62.4637 12.395 66.855C14.8438 69.3075 18.125 70.3913 23 70.8675",
    stroke: "black",
    strokeWidth: 2.08,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.16 6.16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9997 31.815C39.8747 28.1025 41.7497 26.25 45.4997 26.25C50.1722 26.25 52.9997 29.9587 52.9997 33.6675C52.9997 37.3762 51.1247 37.5412 45.4997 41.25V45M45.4997 54.375V56.25M52.9997 71.25C48.3647 71.25 43.2572 73.125 38.5959 75.5438C31.1034 79.4325 27.3572 81.3788 25.5122 80.1375C23.6672 78.9 24.0159 75.0562 24.7172 67.3725L24.8747 65.625",
    stroke: "black",
    strokeWidth: 2.08,
    strokeLinecap: "round",
    strokeDasharray: "6.16 6.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFaq);
export default __webpack_public_path__ + "static/media/emptyFaq.e94a75a9f631854a30ad2fb51d3683cd.svg";
export { ForwardRef as ReactComponent };